<template>
    <DashView>
        <div class="container-fluid pt-4 px-4 pb-5 mb-5">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>&nbsp;Rendez-vous <span class="badge bgbadge">{{rendezvous?.length}}</span> </h3>
                            <div class="table-responsive">
                                <template v-if="rendezvous?.length>0">  
                                    <table class="table table-striped table-bordered display text-center">
                                        <thead>
                                            <tr>
                                                <th>Patient</th>
                                                <th>Médecin</th>
                                                <!-- <th>Note</th> -->
                                                <th>Date</th>
                                                <th>Statut</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="rendez in rendezvous" :key="rendez.id">
                                                    <!-- <td>{{rendez.patient.code_dossier}}</td> -->
                                                    <td><router-link :to="{ name: 'consultation-dossier', params: { dossier: rendez.patient.code_dossier } }" title="Consulter Dossier Patient" @click="redirectTo(`/consultation-dossier/${rendez.patient.code_dossier}`);">{{rendez.patient.code_dossier}}</router-link></td>                                               
                                                    <td>{{rendez.docteur.nom}} {{rendez.docteur.prenom}}</td>
                                                    <!-- <td>{{rendez.note}}</td> -->
                                                    <td><span class="d-inline-flex align-items-center px-2 py-1 rounded-pill" style="background-color: #FFF; color: #00C853;">
                                                        <i class="fas fa-clock me-1"></i>
                                                        {{ formatDate(rendez.date) }} à {{ rendez.heure }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="rounded-pill text-white p-1" v-if="rendez.statut==1" style="background-color: #00C853; box-shadow: 0 2px 6px rgba(0,0,0,0.15); font-weight: 500;">
                                                            {{rendez.statut_label}}
                                                        </span>
                                                        <span v-else class="p-1" style="color: #00C853; font-weight: 500;">
                                                            {{rendez.statut_label}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <a title="Voir" v-if="rendez.statut==1"><i class="fa fa-eye" data-bs-toggle="modal" data-bs-target="#modalRendezVous" @click="loadDataModalRendezVous(rendez.id)"></i></a>
                                                        <span v-else style="color: #00C853;"><i class="fa fa-check" aria-hidden="true"></i></span>
                                                    </td>
                                                </tr>                                
                                        </tbody>
                                    </table>
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
     <!--Begin All Modal -->
         <!-- Modale Gerer Rendez-vous -->
        <div class="modal fade" id="modalRendezVous" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="modalLabel">Gérer le rendez-vous</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                    </div>

                    <div class="modal-body">
                        <p>Souhaitez-vous <strong>accepter</strong> ce rendez-vous ?</p>
                        <ul>
                        <li><strong>Patient : {{ selectRendezVous?.patient?.code_dossier  }} => {{ selectRendezVous?.patient?.nom }} {{ selectRendezVous?.patient?.prenom }}</strong> </li>
                        <li><strong>Date : {{formatDate(selectRendezVous?.date)}} à {{ selectRendezVous?.heure  }}</strong> </li>
                        <li><strong>Note : {{ selectRendezVous?.note }}</strong> </li>
                        </ul>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                        <button type="button" class="btn" style="background-color: #00C853; color: #FFF;" @click="accepterRendezVous(selectRendezVous)">
                        Accepter
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <!-- End All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"RendezVous",
    components:{
        DashView
    },
    data(){
      return{
          rendezvous:[],
          info_assurance:[],
          success_msg:'',
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          selectRendezVous:[]
      }
    },
    created(){
        axios.get(`${base_url}/all_rendez_vous`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data.rendez_vous);
                  if(response.data.rendez_vous){
                      this.rendezvous = response.data.rendez_vous;
                  }                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            if (!dateString) {
                // Si dateString est undefined ou null, retourner une chaîne vide
                return ''; 
            }
            const [year, month, day] = dateString.split('-');
            return `${day}-${month}-${year}`;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        loadDataModalRendezVous(id){
            this.selectRendezVous = this.rendezvous.filter((element)=>element.id==id)[0];
            // console.log(this.selectRendezVous); 
        },
        accepterRendezVous(donnee){
            console.log('Acceptez Rendez-vous!');
            console.log(donnee);
            this.registerDeclassement(donnee);          
            
        },
        registerDeclassement(donnee){
                const $data = {
                    dossier: donnee.patient.code_dossier,
                    service : donnee.service_id,
                    specialite:donnee.specialite_id,
                    docteur: donnee.docteur.id,
                    rendez_vous_id:donnee.id
                };
                console.log('registerDeclassement');
                
                console.log($data);

                axios.post(`${base_url}/declasser_dossier`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Dossier déclassé avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
        },

    }
}
</script>
<style lang="">
    
</style>